var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import PageService from '../../api/PageService';
import KeyConfig from './KeyConfig.vue';
var TableFieldConfig = (function (_super) {
    __extends(TableFieldConfig, _super);
    function TableFieldConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiHeader = false;
        _this.tables = [];
        _this.columns = [];
        _this.allColumns = [];
        _this._allColumns = [];
        _this.slotTable = null;
        _this.isConfigReady = false;
        _this.isColumnReady = false;
        _this.excludeFields = ['操作'];
        return _this;
    }
    TableFieldConfig.prototype.sortColumns = function () {
        var _this = this;
        var cols = cloneDeep(this._allColumns || []);
        var columns = this.columns || [];
        columns.sort(function (a, b) { return a.sort - b.sort; });
        var _a = [[], [], [], []], startArr = _a[0], sortArr = _a[1], newSortArr = _a[2], endArr = _a[3];
        cols.forEach(function (col) {
            if (['selection', 'expand', 'index'].includes(col.type)) {
                col.fixed = true;
                startArr.push(col);
            }
            else if (Array.isArray(_this.fixedRight) && _this.fixedRight.length && _this.fixedRight.includes(col.label))
                endArr.push(col);
            else
                sortArr.push(col);
        });
        var freezeIndex = -1;
        var hiddenColumns = columns.filter(function (col) { return !col.is_freeze && col.is_hidden; });
        var hideColumnsKeys = hiddenColumns.map(function (col) { return col.key; });
        var hideColumnsLabels = hiddenColumns.map(function (col) { return col.name; });
        columns.forEach(function (col, colIndex) {
            var index = sortArr.findIndex(function (item) {
                if (item.children && item.children.length) {
                    if (_this.isMultiHeader)
                        _this.isMultiHeader = true;
                    return col.name.split('-')[0] === item.label && item.children.filter(function (child) { return !hideColumnsKeys.includes(child.property) && !hideColumnsLabels.includes(child.label); }).length > 0;
                }
                return col.key === item.property || item.label === col.name;
            });
            if (index > -1 && !col.is_hidden) {
                var rowData = cloneDeep(sortArr[index]);
                if (rowData.children) {
                    rowData.children = rowData.children.filter(function (child) { return !hideColumnsKeys.includes(child.property) && !hideColumnsLabels.includes(child.label); });
                }
                rowData.fixed = false;
                var label_1 = rowData.label, property_1 = rowData.property;
                var newItemIndex = newSortArr.findIndex(function (item) { return (label_1 && label_1 === item.label) || (property_1 && item.property === property_1); });
                if (newItemIndex === -1)
                    newSortArr.push(rowData);
                else
                    newSortArr.splice(newItemIndex, 1, rowData);
            }
            if (col.is_freeze) {
                freezeIndex = newSortArr.length - 1;
            }
        });
        newSortArr.forEach(function (col, index) {
            if (index <= freezeIndex) {
                col.fixed = 'left';
            }
        });
        console.log('newSortArr>>>', newSortArr);
        return { columns: startArr.concat(newSortArr, endArr) };
    };
    TableFieldConfig.prototype.layoutHeaderWidth = function (table, newColumns) {
        var bodyWidth = table.$el.clientWidth;
        var _origin_columns = table.store.states._origin_columns || [];
        var columns = (newColumns || []).map(function (column) {
            var index = _origin_columns.findIndex(function (col) { return col.type === column.type && ((col.property && col.property === column.property) || (col.label && col.label === column.label)); });
            var newCol = _origin_columns[index] || cloneDeep(column);
            newCol.fixed = column.fixed;
            return newCol;
        });
        var totalWidth = columns.reduce(function (total, column) {
            return total + (column.width || column.realWidth || column.minWidth);
        }, 0);
        console.log('layoutHeaderWidth width>>>', bodyWidth, totalWidth);
        if (bodyWidth > totalWidth) {
            columns.forEach(function (column) {
                var width = column.width || column.realWidth || column.minWidth;
                var newWidth = width / totalWidth * bodyWidth;
                column.width = column.minWidth = column.realWidth = newWidth;
            });
        }
        return columns;
    };
    TableFieldConfig.prototype.updateSlotsTable = function () {
        var _this = this;
        this.$nextTick(function () {
            if (_this.columns.length === 0) {
                console.error('未获取到columns数据');
                return;
            }
            var ElTables = _this.tables || [];
            var newColumns = _this.sortColumns().columns;
            ElTables.forEach(function (table) {
                if (!table.store.states._origin_columns) {
                    table.store.states._origin_columns = cloneDeep(table.store.states._columns);
                }
                var _columns = _this.layoutHeaderWidth(table, newColumns);
                table.store.states._columns = _columns;
                table.store.scheduleLayout(true);
                _this.$nextTick(function () {
                    table.doLayout();
                });
            });
        });
    };
    TableFieldConfig.prototype.configUpdate = function (columns) {
        this.columns.splice(0);
        this.columns = columns;
        this.updateSlotsTable();
    };
    TableFieldConfig.prototype.getPageConfig = function (callBack) {
        var _this = this;
        var params = {
            template_type: this.id
        };
        if (this.businessId) {
            params.business_id = this.businessId;
        }
        this.service
            .getPage(params)
            .then(function (res) {
            var DATA = res.data.data;
            var columns = Array.isArray(DATA.template_config) ? DATA.template_config : [];
            var freezeIndex = columns.findIndex(function (item) { return item.is_freeze; });
            _this.columns = columns.map(function (column, index) {
                column.key = column.type ? column.type + "." + column.key.substring(column.type.length + 1) : column.key;
                if (column.type && columns[index + 1] && column.type === columns[index + 1].type) {
                    column.freezeDisabled = true;
                }
                if (index <= freezeIndex) {
                    column.fixed = true;
                }
                else {
                    column.fixed = false;
                }
                return column;
            });
            _this.isConfigReady = true;
            callBack && callBack();
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    TableFieldConfig.prototype.showKeyConfig = function () {
        var _this = this;
        var columns = this.columns;
        if (this.hideColumnFields && this.hideColumnFields.length) {
            columns = this.columns.filter(function (item) { return !_this.hideColumnFields.includes(item.key); });
        }
        this.$refs.KeyConfig.show(columns, this.id);
    };
    TableFieldConfig.prototype.calcHeaderWidth = function () {
        var _this = this;
        var ElTables = this.tables || [];
        var indexList = [];
        this._allColumns.forEach(function (column) {
            if (column.children && column.children.length) {
                var width = column.children.reduce(function (totalWidth, child) {
                    return totalWidth += child.width;
                }, 0);
                var index = _this.allColumns.findIndex(function (item) { return item.id.includes(column.id); });
                if (index > -1) {
                    indexList.push([index, width, column]);
                    _this.allColumns[index].width = width;
                }
            }
        });
        if (indexList.length > 0) {
            ElTables.forEach(function (table) {
                indexList.forEach(function (item) {
                    table.$children[item[0]]._props.width = item[1];
                    table.$children[item[0]].setColumnWidth && table.$children[item[0]].setColumnWidth(item[2]);
                });
            });
        }
    };
    TableFieldConfig.prototype.initAllColumns = function () {
        var _this = this;
        var load_time = 0;
        var interval = setInterval(function () {
            if (load_time > 60000) {
                clearInterval(interval);
                return;
            }
            load_time += 200;
            _this.tables = _this.findComponentsDownward(_this, 'ElTable') || [];
            var ElTables = _this.tables || [];
            if (ElTables.length === 0) {
                console.error('未监测到el-table');
                return;
            }
            clearInterval(interval);
            _this.allColumns = ElTables[0].columns || [];
            _this._allColumns = cloneDeep(ElTables[0].store.states._columns || _this.allColumns || []);
            _this.isColumnReady = true;
        }, 200);
    };
    TableFieldConfig.prototype.findComponentsDownward = function (context, componentName) {
        var _this = this;
        return context.$children.reduce(function (components, child) {
            if (child.$options.name === componentName)
                components.push(child);
            var foundChilds = _this.findComponentsDownward(child, componentName);
            return components.concat(foundChilds);
        }, []);
    };
    TableFieldConfig.prototype.refresh = function (val, oldVal) {
        var _this = this;
        this.$nextTick(function () {
            _this.getPageConfig();
        });
    };
    TableFieldConfig.prototype.dataReady = function (val) {
        var _this = this;
        if (val) {
            this.$nextTick(function () {
                _this.initAllColumns();
            });
        }
    };
    TableFieldConfig.prototype.isColumnReadyChange = function (val) {
        if (val && this.isColumnReady) {
            this.updateSlotsTable();
        }
    };
    TableFieldConfig.prototype.isConfigReadyChange = function (val) {
        if (val && this.isColumnReady) {
            this.updateSlotsTable();
        }
    };
    TableFieldConfig.prototype.tableDataChange = function (val) {
        var _this = this;
        if (!(val && val.length)) {
            setTimeout(function () {
                _this.layoutTable();
            }, 300);
        }
        else {
            this.layoutTable();
        }
    };
    TableFieldConfig.prototype.bodyHeightChange = function (val) {
        this.layoutTable();
    };
    TableFieldConfig.prototype.resizeStateHeight = function (val) {
        if (val) {
            this.layoutTable();
        }
    };
    TableFieldConfig.prototype.layoutTable = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.tables.forEach(function (table) {
                table.resizeListener();
            });
        });
    };
    TableFieldConfig.prototype.compareColumns = function () {
        var newColumns = this.tables[0].columns || [];
        var allColumns = this.allColumns || [];
        var hasChange = false;
        newColumns.forEach(function (column) {
            if (hasChange)
                return;
            var index = allColumns.findIndex(function (c) { return c.property === column.property; });
            if (index === -1)
                hasChange = true;
        });
        console.time('change');
        console.timeEnd('change');
    };
    TableFieldConfig.prototype.created = function () {
        this.service = PageService.getInstance();
    };
    TableFieldConfig.prototype.mounted = function () {
        this.tables = this.findComponentsDownward(this, 'ElTable') || [];
        if (this.isReady === undefined || this.isReady) {
            this.initAllColumns();
        }
        this.getPageConfig();
    };
    __decorate([
        Prop({
            type: [String, Number],
            default: ''
        })
    ], TableFieldConfig.prototype, "id", void 0);
    __decorate([
        Prop({
            type: [String, Number],
            default: ''
        })
    ], TableFieldConfig.prototype, "businessId", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableFieldConfig.prototype, "multiple", void 0);
    __decorate([
        Prop({
            default: undefined
        })
    ], TableFieldConfig.prototype, "isReady", void 0);
    __decorate([
        Prop({
            default: true
        })
    ], TableFieldConfig.prototype, "showLabel", void 0);
    __decorate([
        Prop({
            default: false
        })
    ], TableFieldConfig.prototype, "useTableColumns", void 0);
    __decorate([
        Prop({
            default: 5
        })
    ], TableFieldConfig.prototype, "fixedLimit", void 0);
    __decorate([
        Prop({
            default: function () {
                return ['操作'];
            }
        })
    ], TableFieldConfig.prototype, "fixedRight", void 0);
    __decorate([
        Prop({
            default: function () {
                return [];
            }
        })
    ], TableFieldConfig.prototype, "hideColumnFields", void 0);
    __decorate([
        Watch("id")
    ], TableFieldConfig.prototype, "refresh", null);
    __decorate([
        Watch("isReady")
    ], TableFieldConfig.prototype, "dataReady", null);
    __decorate([
        Watch("isColumnReady")
    ], TableFieldConfig.prototype, "isColumnReadyChange", null);
    __decorate([
        Watch("isConfigReady")
    ], TableFieldConfig.prototype, "isConfigReadyChange", null);
    __decorate([
        Watch("tableData._props.data")
    ], TableFieldConfig.prototype, "tableDataChange", null);
    __decorate([
        Watch("tableData.layout.height")
    ], TableFieldConfig.prototype, "bodyHeightChange", null);
    __decorate([
        Watch("tableData.resizeState.height")
    ], TableFieldConfig.prototype, "resizeStateHeight", null);
    TableFieldConfig = __decorate([
        Component({
            components: {
                KeyConfig: KeyConfig,
            },
            computed: {
                tableData: function () {
                    var tables = this.tables || [];
                    if (tables.length) {
                        return tables[0];
                    }
                    return {};
                }
            }
        })
    ], TableFieldConfig);
    return TableFieldConfig;
}(Vue));
export default TableFieldConfig;
